import { MessageLabel } from 'stream-chat';

// The type of messages, that produced by real user text
export const messageTypesToNotify: Readonly<MessageLabel[]> = [
  'regular', 'reply',
];
